import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.footer`
  grid-area: footer;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  text-align: center;

  padding-top: 20px;
  padding-bottom: 20px;
  background: var(--footer-background);
  color: var(--footer-font-color);

  @media (min-width: 768px) {
    justify-content: space-between;
    text-align: left;
  }
`;

const Terms = styled.div`
  font-size: 0.75rem;
`;

const Footer = () => {
  return (
    <Wrapper className="justify-content-center container-fluid">
      <Terms className="mb-2 mb-md-0">
        * Terms and Conditions Apply. Your interest rate will depend upon credit score, income, loan amount, loan term, and credit history. APR ranges from 5.99% to 17.99%. For example, if you take out a Future Family loan for $18,000 with an APR of 5.99% and a 60-month term, Future Family will disburse $18,000 to vendors on your behalf and you will make 60 monthly payments of $347.91. Alternatively, if you take out a Future Family loan for $18,000 with an APR of 17.99% and a 60-month term, Future Family will disburse $18,000 to vendors on your behalf and you will make 60 monthly payments of $456.98. No down payment is required and there is no prepayment penalty. Our financing plans do not charge upfront loan fees, but there are membership fees associated with our membership and concierge offerings. Closing of your loan is contingent upon your agreement of all the required agreements and disclosures as required by Future Family or A-Frame Capital, LLC.
      </Terms>
    </Wrapper>
  );
};

export default Footer;
